import Container from "../../common/layout/Container";
import {
    faBinoculars,
    faChartLine,
    faMagnifyingGlassChart,
    faSnowflake,
    faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import Button from "../../common/elements/Button";
import Icon from "../../common/elements/Icon";
import IconCard from "../../common/elements/IconCard";
import { snowflake_urls } from "../../common/Constants";
import "../css/insights.css";

// The in-page bucketing aggregations (formerly served by experimentation-api) are
// deprecated — bucketing insights now live in the Snowflake dashboard, which this
// panel links out to (pre-filtered to the experiment, per environment).
const ENVIRONMENTS = [
    { key: "PROD", label: "Production" },
    { key: "DEV", label: "Dev" },
    { key: "QA", label: "QA" },
];
const DEFAULT_RANGE = "24h";

export const ExperimentStats = (props) => {
    const experimentKey = props.experimentKey;

    return (
        <Container>
            <div className="card has-background-light pb-5">
                <div className="card-content">
                    <IconCard icon={faBinoculars} title={"Stats"} />

                    <div className="notification is-info is-light mt-3">
                        <p className="mb-3">
                            <Icon icon={faSnowflake} />
                            <span className="ml-1">
                                Live bucketing decisions now live in the <strong>Snowflake dashboard</strong>,
                                pre-filtered to this experiment. Open it for the environment you're checking:
                            </span>
                        </p>
                        <div className="buttons">
                            {ENVIRONMENTS.map((env, i) => (
                                <Button key={env.key}
                                        className={i === 0 ? "is-info" : "is-info is-light"}
                                        href={snowflake_urls.bucketDecisions(experimentKey, env.key, DEFAULT_RANGE)}
                                        tooltip={`Open ${env.label} bucketing decisions in Snowflake (new tab)`}>
                                    <Icon icon={faSnowflake} />
                                    <span>{env.label}</span>
                                    <Icon icon={faArrowUpRightFromSquare} />
                                </Button>
                            ))}
                        </div>
                    </div>

                    <div className="divider" />

                    <p className="heading has-text-grey">More tools</p>
                    <div className="buttons">
                        <Button className="is-link has-background-primary"
                                href={"https://prod-useast-a.online.tableau.com/#/site/tripadvisor/workbooks/1198195/views"}
                                tooltip={"See your experiment results in Heimdall"}>
                            <Icon icon={faMagnifyingGlassChart} />
                            <span>Heimdall</span>
                        </Button>
                        <Button className="is-link has-background-primary"
                                href={"https://tripadvisor.grafana.net/d/fa3d5e78-9e82-47c0-a63c-09774191d71d/kinesis-experimentation-clients-metrics?var-period=1m&orgId=1&from=now%2Fd&to=now&timezone=browser&var-cloudwatchsource=cab6d215-1a04-471f-b133-84010a1b587b&var-stream=ExperimentationStream&var-client_application=$__all&var-statistic=Average"}
                                tooltip={"You can see your experiment's metrics in Grafana"}>
                            <Icon icon={faChartLine} />
                            <span>Grafana</span>
                        </Button>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default ExperimentStats;
